import React from 'react';
import styled, { css } from 'styled-components';
import { pl, pt, Margin, mb } from '@nib/layout';
import Heading from '@nib-components/heading';
import { Label, Help } from '@nib-components/form-control';
import Expander from '@nib-components/expander';
const Wrapper = styled.div`
  ${pt(2)};
  ${_ref => {
  let {
    showLeftBorder
  } = _ref;
  return showLeftBorder && css`
      ${pl(4)};
      box-shadow: inset 2px 0 0 0 currentColor;
    `;
}}

  /* Because expander children cannot have vertical margins 
  we are adding our spacing through a transparent border :( */
  border-top: 1rem solid transparent;

  > * {
    ${mb(6)};
  }

  > :last-child {
    margin-bottom: 0 !important;
  }
`;
Wrapper.displayName = 'Wrapper';
const NestedFormFields = _ref2 => {
  let {
    subHeading = '',
    id,
    expanded = false,
    children,
    label,
    help,
    showLeftBorder = true,
    ...otherProps
  } = _ref2;
  return React.createElement(Expander, {
    expanded: expanded,
    id: id
  }, React.createElement(Wrapper, {
    ...otherProps,
    showLeftBorder: showLeftBorder
  }, subHeading && React.createElement(Margin, {
    bottom: 4
  }, React.createElement(Heading, {
    size: 3,
    component: "h3"
  }, subHeading), label && React.createElement(Label, {
    as: "div"
  }, label), help && React.createElement(Help, null, help)), children));
};
NestedFormFields.defaultProps = {
  subHeading: '',
  expanded: false,
  showLeftBorder: true
};
NestedFormFields.displayName = 'NestedFormFields';
export default NestedFormFields;